import { NgModule } from "@angular/core";
import { SharedModule, addNavMenuSection } from "@vendure/admin-ui/core";
import { Permission } from "@vendure/core";

@NgModule({
  imports: [SharedModule],
  providers: [
    addNavMenuSection(
      {
        id: "idea-contact-nav",
        label: "IdeaContacts",
        requiresPermission: "SuperAdmin",
        items: [
          {
            id: "ideacontact",
            label: "IdeaContacts",
            routerLink: ["/extensions/ideacontact"],
            // Icon can be any of https://clarity.design/icons
            icon: "folder-open",
          },
        ],
        // requiresPermission: 'SuperAdmin',
      },
      // Add this section before the "settings" section
      "settings",
    ),
  ],
})
export class IdeaContactExtensionModule {}
